export enum ExtensionType {
  TRANSPORTS = "TRANSPORTS",
  MERCHANDISES = "MERCHANDISES",
}
